import { RootState } from '../root.reducers';
import { IRIBuffering } from './iriBuffering.types';

export const getIRIBuffering = (state: RootState): IRIBuffering | null =>
  state.iriBuffering.single;

export const getSelectedIRIBuffering = (state: RootState): IRIBuffering[] =>
  state.iriBuffering.selected;

export const getIRIBufferingCreatedId = (state: RootState): string | null =>
  state.iriBuffering.createdId;

export const isIRIBufferingCreatePopupOpen = (state: RootState): boolean =>
  state.iriBuffering.ui.isCreatePopupOpen;

export const isIRIBufferingLoading = (state: RootState): boolean =>
  state.iriBuffering.ui.isLoading;
